import { bl_sfa_deal_comment_RowClass } from "../../../dbschema/bl_sfa_deal_comment.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaDealCommentContainerModel extends BaseContainerModel {
    bl_sfa_deal_comment: bl_sfa_deal_comment_RowClass = new bl_sfa_deal_comment_RowClass();
}